<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-09-27 11:04:25
 * @LastEditTime: 2022-11-12 23:35:34
 * @LastEditors: chenguobiao
-->
<template>
  <div class="collection page-normal">
    <common-header />
    <div class="page-normal__content">
      <div class="collection__info-box">
        <div class="title">
          <div class="left-main"><span class="line-bar"></span>补录信息</div>
          <div class="right-back" @click="handleBack">
            <img src="@/render/assets/images/personal/icon_back.png" />返回
          </div>
        </div>
        <el-form :model="formData" :rules="rules" ref="formRef" label-position="top">
          <div class="form-item-row">
            <el-form-item label="考核人姓名" prop="name">
              <el-input v-model="formData.name" :disabled="Boolean(userInfo?.name)" placeholder="成人考生可填写本人姓名" />
            </el-form-item>
            <el-form-item label="所在地区" prop="cascaderCity">
              <china-area v-model="formData.cascaderCity" />
            </el-form-item>
            <el-form-item label="家长姓名" prop="parentName">
              <el-input v-model="formData.parentName" placeholder="成人考生可填写本人姓名" />
            </el-form-item>
            <el-form-item label="与选手关系" prop="relation">
              <el-select v-model="formData.relation" placeholder="请选择与选手关系">
                <el-option v-for="relation in relationList" :key="relation.uid" :label="relation.name"
                  :value="relation.name" />
              </el-select>
            </el-form-item>
          </div>
          <div class="form-item-row">
            <el-form-item label="在读学校" class="club" prop="clubUid">
              <el-select v-model="formData.clubUid" :disabled="Boolean(userInfo?.clubUid)" filterable
                :filter-method="handleClubFilter" reserve-keyword placeholder="请选择在读学校"
                @visible-change="handleClubVisibleChange" @change="handleChangeClub">
                <template v-for="unit in filterUnitList">
                  <el-option v-if="unit" :label="unit.unitName" :value="unit.uid" :key="unit.uid" />
                </template>
              </el-select>
              <el-input v-if="formData.clubName === '其它'" v-model="formData.otherClubName" placeholder="请输入在读学校"
                autocomplete="off" />
            </el-form-item>


            <el-form-item label="学棋始于日期" prop="studyTime">
              <el-date-picker v-model="formData.studyTime" type="date" value-format="yyyy-MM-dd"
                placeholder="请选择学棋始于日期" />
            </el-form-item>
            <el-form-item label="家长手机号" prop="parentPhone" class="mobile">
              <el-input v-model="formData.parentPhone" :disabled="Boolean(userInfo?.parentPhone)"
                placeholder="成人考生可填写本人手机号" autocomplete="off" />
              <!-- <div class="send-message" @click="handleClickSendMessage">
                {{ countDownTimes === 0 ? '获取验证码' : countDownTimes + 's' }}
              </div> -->
            </el-form-item>
            <el-form-item label="在训机构" class="club" prop="organizationUid">
              <el-select v-model="formData.organizationUid" :disabled="Boolean(userInfo?.organizationUid)" filterable
                :filter-method="handleOrganizationFilter" reserve-keyword placeholder="请选择在训机构名称"
                @visible-change="handleOrganizationVisibleChange" @change="handleChangeOrganization">
                <el-option v-for="organization in filterOrganizationList" :label="organization.organizationName"
                  :value="organization.uid" :key="organization.uid" />
              </el-select>
              <el-input v-if="formData.organizationName === '其它'" v-model="formData.otherOrganizationName"
                placeholder="请输入在训机构" autocomplete="off" />
            </el-form-item>
            <!-- <el-form-item label="短信验证码" prop="code">
              <el-input v-model="formData.code"></el-input>
            </el-form-item> -->
          </div>
          <div class="form-item-row attachment border">
            <el-form-item label="证件类型" prop="cardTypeUid">
              <el-select v-model="formData.cardTypeUid" :disabled="Boolean(userInfo?.cardTypeUid)"
                @change="handleIdentityChange" placeholder="请选择证件类型">
                <el-option v-for="identity in identityList" :key="identity.uid" :label="identity.name"
                  :value="identity.uid" />
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码" prop="card">
              <el-input v-model.trim="formData.card" :disabled="Boolean(userInfo?.card)" placeholder="请输入证件号码"
                autocomplete="off" />
            </el-form-item>
            
            <el-form-item class="attachment--certificate no--border" label="是否有考级证书" prop="certificateState">
              <label class="diy--label" slot="label">
                <div class="diy--label--text">是否有考级证书</div>
                <el-tooltip effect="dark" placement="right">
                  <div slot="content">若有考级证书，可上传已获<br />考级证书原件图片,平台将<br />根据考级证书同步你当前国<br />际象棋棋力等级，文件大小<br />限制5M。
                  </div>
                  <div class="icon-question">
                    <img src="@/render/assets/images/auth/icon-question.png" />
                  </div>
                </el-tooltip>
              </label>
              <div style="display:flex;align-items:center;">
                <el-radio v-model="formData.certificateState" :label="1">是</el-radio>
                <el-radio v-model="formData.certificateState" :label="2">否</el-radio>
              </div>
            </el-form-item>
            <el-form-item label="邀请码输入" prop="invitationCode">
              <el-input v-model.trim="formData.invitationCode" placeholder="没有请填写无" autocomplete="off" />
            </el-form-item>
          </div>
          <div class="form-item-row attachment">
            <el-form-item class="no--border attachment--idCard" required>
              <label slot="label">
                证件照片
                <el-tooltip effect="dark" placement="right">
                  <div slot="content">可上传身份证照片正反面或户口本个人信息页，<br />仅支持图片，格式为png、jpg、jpeg，<br />大小限制5M</div>
                  <div class="icon-question">
                    <img src="@/render/assets/images/auth/icon-question.png" />
                  </div>
                </el-tooltip>
              </label>
              <div class="upload--attachment--list">
                <upload-attachment v-model="formData.picUrls[0]" :url="formData.picUrls[0]" type="idCard" />
                <upload-attachment v-model="formData.picUrls[1]" :url="formData.picUrls[1]" type="idCard" />
              </div>
            </el-form-item>
            
            <el-form-item class="no--border attachment--certificate--upload" v-if="formData.certificateState === 1"
              required>
              <label slot="label">
                上传棋力证书
                <el-tooltip effect="dark" content="请上传国际象棋棋力认证证书原件相关证明图片，文件大小限制5M" placement="right">
                  <div slot="content">请上传国际象棋棋力认证<br />证书原件相关证明图片，<br />文件大小限制5M</div>
                  <div class="icon-question">
                    <img src="@/render/assets/images/auth/icon-question.png" />
                  </div>
                </el-tooltip>
              </label>
              <div class="upload--attachment--list">
                <upload-attachment v-model="formData.certificatePicUrl[0]" :url="formData.certificatePicUrl[0]"
                  type="certificate" />
                <upload-attachment v-model="formData.certificatePicUrl[1]" :url="formData.certificatePicUrl[1]"
                  type="certificate" />
              </div>
            </el-form-item>
            <el-form-item class="attachment--application--level" prop="levelUid" label="对应申请等级"
              v-if="formData.certificateState === 1" required>
              <el-select v-model="formData.levelUid" @change="handleGradeChange" placeholder="请选择证书等级">
                <el-option v-for="grade in gradeList" :key="grade.uid" :label="grade.showName" :value="grade.uid" />
              </el-select>
            </el-form-item>

          </div>
        </el-form>
        <div class="collection-button" @click="handleConfirm">
          <div class="collection-button__bg">
            <img src="@/render/assets/images/auth/collection-button.png" />
          </div>
        </div>
      </div>
    </div>
    <confirm-dialog :visible="confirmDialogConfig.visible" :desc="confirmDialogConfig.desc"
      @confirm="handleDialogConfirm" :showCancel="false" />
  </div>
</template>

<script>
import _ from 'lodash'
import store from 'store'
import { USER_INFO, COUNTDOWN } from '@/config/const'
import CommonHeader from '@/render/components/common/header'
import chinaArea from '@/render/components/common/china-area'
import uploadAttachment from '../../auth/components/uploadAttachment'
import { deepClone, Timer } from '@/render/utils'
import { authAPI } from '@/apis'
import { ConfirmDialog } from '@/render/components/dialog'
let timer = null
const validateMobile = (rule, value, callback) => {
  if (!value) {
    return new Error('请输入电话号码')
  } else {
    const reg = /^1[3-9]\d{9}$/
    const isPhone = reg.test(value)
    value = Number(value) // 转换为数字
    if (typeof value === 'number' && !isNaN(value)) {
      // 判断是否为数字
      value = value.toString() // 转换成字符串
      if (value.length < 0 || value.length > 12 || !isPhone) {
        // 判断是否为11位手机号
        callback(new Error('手机号码格式如:138xxxx8754'))
      } else {
        callback()
      }
    } else {
      callback(new Error('请输入电话号码'))
    }
  }
}
const idCardValidity = (rule, code, callback) => {
  var city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 ',
  }
  var tip = ''
  var pass = true

  if (
    !code ||
    !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
      code,
    )
  ) {
    tip = '身份证号格式错误'
    pass = false
  } else if (!city[code.substr(0, 2)]) {
    tip = '地址编码错误'
    pass = false
  } else {
    // 18位身份证需要验证最后一位校验位
    if (code.length === 18) {
      code = code.split('')
      // ∑(ai×Wi)(mod 11)
      // 加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      // 校验位
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
      var sum = 0
      var ai = 0
      var wi = 0
      for (var i = 0; i < 17; i++) {
        ai = code[i]
        wi = factor[i]
        sum += ai * wi
      }
      if (parity[sum % 11] != code[17]) {
        tip = '校验位错误'
        pass = false
      }
    }
  }
  if (!pass) {
    callback(new Error(tip))
  } else {
    callback()
  }
}
const invitationCodeReg = /^(?=(?:[^0-9]*[0-9]){3}[^0-9]*$)(?=(?:[^a-zA-Z]*[a-zA-Z]){1}[^a-zA-Z]*$).*/
export default {
  name: 'Collection',
  data() {
    return {
      countDownTimes: 0,
      userInfo: null,
      formData: {
        uid: this.$route.query.uid,
        name: '', // 名称
        cardTypeUid: '', // 身份类型uid 字典
        cardTypeName: '', // 身份类型名称
        card: '', // 身份证号码
        provinceUid: '', // 省
        cityUid: '', // 市
        areaUid: '', // 区
        cascaderCity: '', // 联合省市区
        parentName: '', // 家长
        parentPhone: '', // 家长联系方式
        code: '', // 验证码
        relation: '', // 家长关系
        studyTime: '', // 学习时间 “2020-05-02”
        clubName: '', // 俱乐部（学校）
        clubUid: '', // 俱乐部单位的uid（下拉）
        picUrls: ['', ''],
        certificateState: '', // 是否有考核证书状态 1：是 2：否 （默认为否）
        certificateUrl: '', // 考核证书状态为是后，该字段必填
        certificatePicUrl: ['', ''],
        levelUid: '',
        levelName: '',
        organizationUid: '', // 机构的uid
        organizationName: '', // 机构名称
        invitationCode: '无',


        // "uid": "051d4ecc90a461c7c0503207a1c7ddcb",
        // "name": "陈某",
        // "avatarUrl": "http://test.zjhzxinzhihui.com/upload/2024-08-07/20240807_203344928.png",
        // "sex": 1,
        // "age": "1993-01-08",
        // "cardTypeUid": "12530ae8818b4d2bdb20b8cb38040fd4",
        // "cardTypeName": "中国身份证（包含港澳台）",
        // "card": "342626199301084576",
        // "clubName": "杭州市祥符艺术幼儿园",
        // "studyTime": "2024-08-05",
        // "parentName": "陈某某",
        // "relation": "父子",
        // "parentPhone": "17887241862",
        // "provinceUid": "",
        // "cityUid": "",
        // "areaUid": "",
        // "cascaderCity": "北京市|市辖区|东城区",
        // "loginName": "chen2024",
        // "password": "1qaz@WSX",
        // "code": "022275",
        // "picUrls": [
        //   "http://test.zjhzxinzhihui.com/upload/2024-08-07/20240807_204046171.png",
        //   "http://test.zjhzxinzhihui.com/upload/2024-08-07/20240807_204048212.png"
        // ],
        // "certificateState": 2,
        // "certificateUrl": "",
        // "certificatePicUrl": [
        //   "",
        //   ""
        // ],
        // "clubUid": "016f09e72aa8ad3790abbce0785d5edd",
        // "levelUid": "",
        // "levelName": "",
        // "organizationUid": "044c6cbb2aea1846ef2aac5a63056317",
        // "organizationName": "鑫棋道",
        // "userType": 0,
        // "invitationCode": "无"
      },
      rules: {
        name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        cardTypeUid: [
          { required: true, message: '请选择证件类型', trigger: 'change' },
        ],
        card: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          {
            pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
            message: '请输入正确的证件号',
          },
          { validator: idCardValidity, trigger: 'blur' },
        ],
        levelUid: [
          { required: true, message: '请选择对应申请等级', trigger: 'change' },
        ],
        clubUid: [
          { required: true, message: '请选择在读学校', trigger: 'change' },
        ],
        parentPhone: [
          { required: true, message: '请输入家长手机号', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' },
        ],
        cascaderCity: [
          { required: true, message: '请选择所在地区', trigger: 'blur' },
        ],
        // code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        organizationUid: [
          { required: true, message: '请选择机构', trigger: 'change' },
        ],
        certificateState: [
          { required: true, message: '请选择是否有考级证书', trigger: 'change' },
        ],
        // invitationCode: [
        //   { required: true, message: '没有请填写无', trigger: 'blur' }
        // ]
      },
      identityList: [],
      idCardUid: '9670a469783e880a515aa6ed549f78b1',
      relationList: [],
      unitList: [], // 单位列表
      organizationList: [], // 机构列表
      confirmDialogConfig: {
        visible: false,
        desc: '',
      },
      gradeList: [],
      clubQuery: '',
      organizationQuery: ''
    }
  },
  computed: {
    filterUnitList() {
      const _filterUnitList = this.unitList.filter(unit => unit.unitName.indexOf(this.clubQuery) > -1)
      if (_filterUnitList.length > 0) {
        return _filterUnitList
      } else {
        return this.unitList.filter(unit => unit.unitName.indexOf('其它') > -1)
      }
    },
    filterOrganizationList() {
      const _filterOrganizationList = this.organizationList.filter(unit => unit.organizationName.indexOf(this.organizationQuery) > -1)
      if (_filterOrganizationList.length > 0) {
        return _filterOrganizationList
      } else {
        return this.organizationList.filter(unit => unit.organizationName.indexOf('其它') > -1)
      }
    }
  },
  watch: {
    'formData.card': function (card) {
      this.$refs.formRef.validateField('card', async errorMessage => {
        if (errorMessage === '') {
          this.generateBirth(card)
        } else {
          this.formData.age = ''
        }
      })
    },
    '$route.query': {
      immediate: true,
      handler(query) {
        query.uid && this.handleGetUserInfo(query.uid)
      }
    }
  },
  components: {
    CommonHeader,
    chinaArea,
    uploadAttachment,
    ConfirmDialog,
  },
  mounted() {
    this.getIdentityList()
    this.getRelationList()
    this.getGradeList()
    this.getUnitList()
    this.getOrganizationList()
  },
  methods: {
    handleClubFilter(query) {
      this.clubQuery = query
    },
    handleClubVisibleChange(visible) {
      if (visible) {
        this.clubQuery = ''
      }
    },
    handleOrganizationFilter(query) {
      this.organizationQuery = query
    },
    handleOrganizationVisibleChange(visible) {
      if (visible) {
        this.organizationQuery = ''
      }
    },
    async handleGetUserInfo(uid) {
      const keys = ['name', 'parentPhone', 'cardTypeUid', 'card', 'clubUid', 'clubName', 'organizationUid', 'organizationName']
      const result = await authAPI.getGetUserInfo({
        uid
      })
      this.userInfo = result?.data
      keys.forEach(key => {
        if (this.userInfo[key]) {
          this.formData[key] = this.userInfo[key]
        }
      })
      this.userInfo["cardTypeUid"] && this.handleSetCardRule(this.userInfo["cardTypeUid"])
    },
    generateBirth(customercode) {
      if (this.formData.cardTypeUid === this.idCardUid) {
        this.formData.age =
          customercode.substring(6, 10) +
          '-' +
          customercode.substring(10, 12) +
          '-' +
          customercode.substring(12, 14)
      }
    },
    handleChangeClub(clubUid) {
      const club = this.unitList.find(ele => ele.uid === clubUid)
      this.formData.clubName = club.unitName
    },
    handleChangeOrganization(organizationUid) {
      const organization = this.organizationList.find(
        ele => ele.uid === organizationUid,
      )
      this.formData.organizationName = organization.organizationName
    },
    handleSetCardRule(value) {
      if (value === this.idCardUid) {
        this.rules.card = [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          {
            pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
            message: '请输入正确的证件号',
          },
          { validator: idCardValidity, trigger: 'blur' },
        ]
      } else {
        this.rules.card = [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
        ]
      }
    },
    handleIdentityChange(value) {
      const findIdentity = this.identityList.find(
        identity => identity.uid === value,
      )
      this.formData.cardTypeName = findIdentity.name
      this.handleSetCardRule(value)

    },
    handleGradeChange(value) {
      const idx = this.gradeList.findIndex(grade => grade.uid === value)
      Object.assign(this.formData, {
        levelUid: this.gradeList[idx].uid,
        levelName: this.gradeList[idx].name,
      })
    },
    async getIdentityList() {
      const result = await authAPI.postGetListByCode({ code: 'certificates' })
      this.identityList = result.data
      if (!this.formData.cardTypeUid) {
        const idx =
          this.identityList.findIndex(ele => ele.name.indexOf('身份证') > -1) || 0
        this.formData.cardTypeUid = this.identityList[idx].uid
        this.formData.cardTypeName = this.identityList[idx].name
      }
    },
    async getRelationList() {
      const result = await authAPI.postGetListByCode({ code: 'relation' })
      this.relationList = result.data
    },
    async getGradeList() {
      const result = await authAPI.postGetListByCode({
        code: 'test-grade',
        field: 'sort',
      })
      const gradeList = result.data.sort((prev, next) => {
        return next.name - prev.name
      })
      this.gradeList = gradeList.map(grade => {
        if (grade.name === '17') {
          grade.showName = '无等级'
        } else {
          grade.showName = `国际象棋${grade.name}级`
        }
        return grade
      })
    },
    async getOrganizationList() {
      const result = await authAPI.postGetOrganizationList({
        organizationName: '',
      })
      this.organizationList = result.data
    },
    async getUnitList() {
      const result = await authAPI.postGetUnitList({
        unitName: '',
      })
      this.unitList = result.data
    },
    handleBack() {
      window.history.back()
    },
    async handleClickSendMessage() {
      if (this.countDownTimes !== 0) return false
      try {
        await authAPI.postSendSmsCode({
          phone: this.formData.parentPhone,
          type: 1,
        })
        this.countDownTimes = 60
        timer = new Timer(this.countDownTimes)
        timer.start(this.$bus, COUNTDOWN)
        this.$bus.on(COUNTDOWN, countDownTimes => {
          this.countDownTimes = countDownTimes
        })
      } catch (error) {
        throw error
      }
    },
    handleDialogConfirm() {
      window.history.back()
    },
    async handleSubmitForm() {
      const { parentPhone: phone, code } = this.formData

      // await authAPI.postCheckSmsCode({ phone, code, type: 1 })
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          let submitFormData = deepClone(this.formData)
          submitFormData.picUrls = submitFormData.picUrls.filter(url => url !== '').join(',')
          submitFormData.certificatePicUrl = submitFormData.certificatePicUrl.filter(url => url !== '').join(',')
          const arr = submitFormData.cascaderCity.split('|')
          submitFormData.province = arr[0]
          submitFormData.city = arr[1]
          submitFormData.area = arr[2]
          delete submitFormData.cascaderCity
          const { code, data, msg } = await authAPI.postUserSupply(
            submitFormData,
          )
          if (code === 0) {
            this.$store.commit('auth/setToken', data.token)
            store.set(USER_INFO, data)
            this.$message({
              message: '补录信息成功',
              type: 'success',
            })
            setTimeout(() => {
              this.$router.push('/home')
            })
          } else {
            this.confirmDialogConfig = {
              visible: true,
              desc: data,
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleConfirm: _.throttle(async function () {
      if (!this.formData.clubName) {
        this.$message.error('请选择在读学校（学校）名称')
        return
      }
      if (!this.formData.picUrls[0] && !this.formData.picUrls[1]) {
        this.$message.error('请上传证件，个数2张！')
        return
      }
      if (
        this.formData.certificateState === 1 &&
        (!this.formData.certificatePicUrl[0] &&
          !this.formData.certificatePicUrl[1])
      ) {
        this.$message.error('请上传考级证书，至少1张！')
        return
      }
      // if (this.formData.invitationCode === "无") {
      //   this.$confirm('是否无邀请码？', '提示', {
      //     confirmButtonText: '是',
      //     cancelButtonText: '否',
      //   })
      //     .then(this.handleSubmitForm)
      //   return
      // }
      // if (!invitationCodeReg.test(this.formData.invitationCode)) {
      //   this.$message.error('邀请码格式不正确')
      //   return
      // }
      this.handleSubmitForm()
    }),
  },
}
</script>

<style lang="scss" scoped>
.collection {
  &__info-box {
    position: relative;
    margin: val(77) auto 0;
    padding: val(66) val(106) 0;
    width: val(1500);
    height: val(800);
    background-color: #fff;
    box-shadow: 0px 13px 35px rgba(0, 0, 0, 0.14);
    border-radius: val(15);
    background: url(../../../assets/images/personal/chess_bg.png) #fff left top no-repeat;
    background-size: 100%;

    .title {
      display: flex;
      justify-content: space-between;
      margin-bottom: val(66);

      .left-main {
        display: flex;
        align-items: center;
        font-size: val(24);
        font-weight: 500;
        color: #4e2500;

        .line-bar {
          margin-right: val(5);
          width: val(6);
          height: val(16);
          background-color: #4e2500;
        }
      }

      .right-back {
        font-size: val(18);
        line-height: val(32);
        color: #0077e8;
        cursor: pointer;
        display: flex;
        align-items: center;

        img {
          width: val(16);
          margin-right: val(6);
        }
      }
    }

    .form-item-row {
      display: flex;

      // align-items: flex-start;
      &.attachment {
        .el-form-item {
          &.no--border {
            ::v-deep .el-form-item__content {
              border: none;
            }
          }

          ::v-deep {
            .el-form-item__label {
              display: flex;
            }

            .el-form-item__content {
              display: block;

              .upload--attachment--list {
                display: flex;
                align-items: center;
                width: 100%;

                .attachment-uploader {
                  margin-right: val(10);

                  .attachment-uploader-icon {
                    width: val(82);
                    height: val(82);
                    line-height: val(82);
                  }
                }
              }
            }
          }

          .tips {
            font-size: val(14);
            color: red;
          }

          /* &.attachment--idCard {
            margin-right: val(345);
          } */
        }

        .icon-question {
          display: inline-block;
          width: val(16);
          vertical-align: middle;
          margin-left: val(4);
        }

        .attachment--certificate {
          &--upload {
            &__tips {
              // width: val(134);
              margin-left: val(14);
              font-size: val(14);
              line-height: val(22);
              color: #d7d6d6;
            }
          }

          .icon-question {
            margin: 0 val(6) 0 val(6);
          }

          .select--level {
            display: flex;
            align-items: center;
            margin-top: val(16);

            span {
              width: val(100);
              font-size: val(14);

              &:before {
                content: '*';
                color: #f56c6c;
                margin-right: 4px;
              }
            }

            ::v-deep .el-select {
              .el-input__inner {
                border-bottom: 1px solid rgba(180, 190, 215, 0.52);
                border-radius: 0;
              }
            }
          }
        }

        .attachment--application--level {
          display: flex;
          align-items: flex-start;

          ::v-deep {

            .el-form-item__label,
            .el-form-item__content {
              position: relative;
              top: val(-10);
            }

            .el-form-item__label {
              margin-right: val(10);
              padding: 0;
              line-height: val(37);
            }

            .el-form-item__content {
              flex: 1;
            }
          }
        }
      }

      .el-form-item {
        margin-right: val(50);
        margin-bottom: 0;

        &:last-of-type {
          margin: 0;
        }

        &.club {
          ::v-deep {
            .el-form-item__content {
              border: none;
              display: flex;
              align-items: center;

              .el-select {
                border-bottom: 1px solid rgba(180, 190, 215, 0.52);
                flex: 1;

                .el-input {
                  border: none;
                  margin: 0;
                  width: unset;
                }
              }

              .el-input {
                width: val(133);
                border-bottom: 1px solid rgba(180, 190, 215, 0.52);
                margin-left: val(10);
              }
            }
          }

          .club__select {
            display: flex;
          }
        }

        &.mobile {
          ::v-deep .el-form-item__content {
            position: relative;
            //padding-right: val(120);

            .send-message {
              width: val(106);
              cursor: pointer;
              position: absolute;
              right: 0;
              bottom: 0;
              padding: 0 0 val(10) val(13);
              font-size: val(16);
              color: #0077e8;
              box-sizing: border-box;

              &:before {
                content: '';
                position: absolute;
                left: 0;
                top: val(2);
                width: 1px;
                height: val(12);
                background: #b4bed7;
                opacity: 0.52;
              }
            }
          }
        }

      }
    }
  }

  &-button {
    position: absolute;
    left: 50%;
    bottom: val(64);
    transform: translateX(-50%);
    width: val(386);
    cursor: pointer;
  }

  .diy--label {
    display: flex;
    align-items: center;
  }
}
</style>
<style lang="scss">
.collection {
  .form-item-row {
    margin-bottom: val(32);

    .el-form-item {
      width: val(244);
      margin: 0;

      .el-form-item__content {
        line-height: unset;
        float: left;
        width: 100%;

        .icon-edit {
          cursor: pointer;
          position: absolute;
          width: val(13);
          right: val(9);
          bottom: val(9);
        }

        .el-cascader--small {
          line-height: unset;

          .el-input--small .el-input__icon {
            line-height: unset;
          }
        }
      }

      .el-select {
        display: block;

        .el-input__prefix,
        .el-input__suffix {
          display: none;
        }
      }

      .el-icon-date {
        display: none;
      }

      .el-radio {
        display: flex;
        align-items: center;
        margin-right: val(20);

        &:last-of-type {
          margin: 0;
        }

        &__inner {
          width: 10px;
          height: 10px;
        }

        &__label {
          font-size: val(16);
          padding-left: val(6);
        }
      }

      .el-input {
        .el-input__inner {
          background-color: #fff;
          border: none;
          padding: 0;
          height: val(37);
          line-height: val(37);
          font-size: val(16);
          color: #111;
        }
      }

      .el-form-item__label {
        float: left;
        font-size: val(16);
        color: #5e3c00;
        line-height: 1em;
        vertical-align: unset;
        padding-bottom: val(12);
      }

      .el-form-item__content {
        border-bottom: 1px solid rgba(#b4bed7, 0.52);
      }
    }

    .el-cascader {
      width: 100%;
    }
  }
}
</style>
